import styled from 'styled-components';

export const ScrollContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  scrollbar-width: none;
`;
export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom:15px;
  font-weight: 500;
  color: #323131;
`;
